// Central place to swap gallery images later.
// Replace `src` with your own portfolio photo URLs/paths.

const folder = 'Kiki - Photography ' // yes, trailing space in folder name
const folderEncoded = encodeURIComponent(folder)

const files = [
  'photo.jpg',
  'photo copy.jpg',
  'photo-1.jpg',
  'photo-2 (2).jpg',
  'photo-3 (1).jpg',
  'photo-4.jpg',
  'photo-5.jpg',
  'photo-6.jpg',
  'photo-7.jpg',
  'photo-8.jpg',
  'photo-9.jpg',
  'photo-10.jpg',
  'photo-11.jpg',
  'photo-12.jpg',
  'photo-13.jpg',
  'photo-14.jpg',
  'photo-15.jpg',
  'photo-16.jpg',
  'photo-17.jpg',
  'photo-18.jpg',
  'photo-19.jpg',
  'photo-20.jpg',
  'photo-21.jpg',
  'photo-22.jpg',
  'photo-23.jpg',
  'photo-24.jpg',
  'photo-25.jpg',
  'photo-27.jpg',
  'photo-28.jpg',
  'photo-29.jpg',
  'photo-33.jpg',
  'photo-34.jpg',
  'photo-35.jpg',
  'photo-36.jpg',
  'photo-37.jpg',
  'photo-39.jpg',
  'photo-40.jpg',
  'photo-41.jpg',
  'photo-42.jpg',
  'photo-43.jpg',
  'photo-44.jpg',
  'photo-45.jpg',
  'photo-47.jpg',
  'photo-48.jpg',
  'photo-49.jpg',
  'photo-52.jpg',
  'photo-53.jpg',
  'photo-54.jpg',
  'photo-55.jpg',
  'photo-56.jpg',
  'photo-58.jpg',
  'photo-59.jpg',
  'photo-60.jpg',
  'photo-62.jpg',
  'photo-63.jpg',
]

export const GALLERY_ITEMS = files.map((file, idx) => ({
  id: `kiki-photo-${idx + 1}`,
  src: `/${folderEncoded}/${encodeURIComponent(file)}`,
  alt: 'Gallery photo',
}))

